import { FieldProps } from 'formik'
import { FormikDropdown } from 'formik-office-ui-fabric-react'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import { IDropdownOption } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

export class ProvingDetailsTransportFormSchema {
  constructor() {
    return Yup.object().shape({
      transport: Yup.string().required(),
    })
  }
}

export interface ProvingDetailsTransportValues {
  Transport: string
}

export const ProvingDetailsSimpleTransportForm: React.FunctionComponent =
  () => {
    const { t } = useTranslation()

    const options: IDropdownOption[] = [
      { key: 'noTransport', text: t('dropdown.option.tNoTransport') },
      {
        key: 'outboundAndReturnTransport',
        text: t('dropdown.option.tOutboundAndReturnTransport'),
      },
      {
        key: 'outboundTransport',
        text: t('dropdown.option.tOutboundTransport'),
      },
      { key: 'returnTransport', text: t('dropdown.option.tReturnTransport') },
    ]

    return (
      <FormStack>
        <FieldStack>
          <FieldStackItem
            name="transport.transportType"
            isRequired={true}
            render={(fieldProps: FieldProps<ProvingDetailsTransportValues>) => (
              <FormikDropdown
                label={t('field.transport.label')}
                {...fieldProps}
                options={options}
              />
            )}
          />
        </FieldStack>
      </FormStack>
    )
  }
